module.exports = __webpack_public_path__ + "static/media/dev-logo.33953a8f.webp";